function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 17 18",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("path", {
  d: "M6.15 17.19c.57 0 .87-.41 1.18-1.02 1.19-2.35 2.8-4.25 4.04-5.88a6.9 6.9 0 001.58-4.48C12.99 2.85 10.59.6 6.82.57h-1.1C4.66.54 3.88.62 3.44.73 2.82.9 2.2 1.29 2.2 2.07c0 .31.09.53.2.7.06.11.04.2-.04.24-.51.21-.93.67-.93 1.32 0 .36.1.68.28.92.1.12.07.22-.07.3-.38.21-.62.67-.62 1.2 0 .37.12.78.34.98.12.11.1.19-.04.3-.26.2-.4.59-.4 1.05 0 .78.6 1.42 1.4 1.42h2.86c.73 0 1.21.37 1.21.97 0 1.1-1.36 3.1-1.36 4.52 0 .75.48 1.2 1.12 1.2zm7.56-7c1.82 0 3.2-1.94 3.2-4.44 0-2.4-1.48-4.42-3.5-4.42H12a5.27 5.27 0 012.08 4.5 6.98 6.98 0 01-1.54 4.36h1.18z",
  fill: "#FFF"
})));